export const MARS4_COEF = Math.pow(10, 18);
export const ETH_COEF = Math.pow(10, 18);
export const USDT_COEF = Math.pow(10, 6);
export const USD_COEF = Math.pow(10, 2);
export const TOP_UP_WALLET_ADDRESS_DEFAULT = '0xc986D410593919520970583D9EDc21ba74996B72';

export const DIV_TO_SCROLL_FOR_BANNER_ID = 'div-to-scroll-for-banner';
export const BANNER_START_TIME = 1668592800000;
export const BANNER_END_TIME = 1669024800000;
export const SUBSCRIBE_BANNER_START_TIME = 1669024800000;
export const SUBSCRIBE_BANNER_END_TIME = 1669197600000;

export const MAILERLITE_API_URL = 'https://connect.mailerlite.com';
export const MAILERLITE_SUBSCRIBE_PATH = '/api/subscribers';
export const MAILERLITE_API_KEY = '51fd9aba06671672dad0b944ae0f4e9';
export const MAILERLITE_SUBSCRIBE_GROUP_ID = '111675524';

export const LAND_NFTS_URL = 'https://app.mars4.me/nft-sale';
export const CDN_URL = 'https://mars4me-cdn.fra1.cdn.digitaloceanspaces.com';
export const OPENSEA_KARKANDA_NFTS_URL = 'https://opensea.io/collection/karkanda-key-nfts';
export const OPENSEA_MARSMASKS_NFTS_URL = 'https://opensea.io/collection/mars4-masks';
export const MARSMASKS_NFTS_URL = 'https://www.mars4.me/marsmasks';
export const COLONIST_STATS_URL =
  'https://whitepaper.mars4.me/mars4-control-center/colonists-and-in-game-nfts/colonist-mcc-balance';

export const DISCORD_UPDATES_CHANNEL = 'https://discord.com/channels/859749888429916170/1070259842582843412';
export const SOCIAL_CHANNELS = {
  youtube: 'https://www.youtube.com/channel/UCdzyC4xEyG5T4o0q4Ubh6VQ',
  telegram: 'https://t.me/mars4me_official',
  twitter: 'https://twitter.com/MARS4_me',
  discord: 'https://discord.gg/uKxj3YeE85',
  facebook: 'https://www.facebook.com/mars4.me',
  linkedin: 'https://www.linkedin.com/company/mars4/',
};

export const ERTHA_REDIRECT_URL =
  process.env.REACT_APP_METAMASK_HOST === 'mainnet'
    ? 'https://control.ertha.com/'
    : 'https://control-testnet.ertha.com/';

export const VIDEO_URL = {
  marsIntro: 'https://www.youtube.com/embed/Jt3d-OozHyo?autoplay=1&mute=1',
  marsMining: 'https://www.youtube.com/embed/GvPTt1RurrM?autoplay=1&mute=1',
  marsExploration: 'https://www.youtube.com/embed/Vg6GshZx2-s?autoplay=1&mute=1',
  marsTopUp: 'https://www.youtube.com/embed/Qk84UrsmL88?autoplay=1&mute=1',
  payWithCard: 'https://www.youtube.com/embed/tOE9jxJnaas?autoplay=1&mute=1',
};

export const QUERY_OPTIONS = {
  filterKey: 'filter',
  pageKey: 'pageIndex',
  searchKey: 'search',
  limitKey: 'limit',
  sectionKey: 'section',
  sortId: 'sortId',
  sortDirection: 'sortDirection',
  type: 'type',
};

export const DATES = {
  milliseconds15Days: 1000 * 60 * 60 * 24 * 15,
  clickBeetlePackStart: new Date('2023-07-05T00:00:00+0300'),
  clickBeetlePackEnd: new Date('2023-07-20T00:00:00+0300'),
};

export const ALLIANCE = {
  maxMembersCount: 20,
};
